// 繁體中文語言包
// 注意：這是基礎語言，所有的key都是簡體中文，value也是簡體中文
// 這樣設計的目的是讓開發時直接使用中文作為key，便於理解和維護

export default {
  // 算力申請頁面 - Computing.vue
  computing: {
    // 頁面標題和基礎信息
    '平台资产': '平臺資產',
    '质押金额': '算力金額',
    '算力周期': '算力周期',
    '天': '天',
    '算力类型': '算力類型',
    '基础算力': '基礎算力',
    '高级算力': '高級算力',
    '超级算力': '超級算力',
    '企业算力': '企業算力',
    '高性能': '高性能',
    '标准': '標準',
    '经济型': '經濟型',
    '申请算力': '申請算力',
    '可申请次数': '可申請次數',
    '剩余次数': '剩餘次數',
    '短算力类型': '類型',
    '短算力周期': '周期',
    '短预计日收益': '日收益',
    '短剩余次数': '剩餘',
    '短解押记录': '贖回記錄',
    '短算力记录': '租賃記錄',
    '短质押明细': '算力明細',
    '短待审': '待審',
    '短成功': '成功',
    '短失败': '失敗',
    '短完成': '完成',
    '超级算力申请': '算力租賃',

    '步骤提示租赁': '步驟1 選擇算力方案 · 步驟2 點擊「算力租賃」完成',
    '请选择算力方案': '請選擇算力方案',
    '请先选择算力方案': '請先選擇算力方案後再點擊算力租賃',    '算力收益等级': '算力收益等級',
    '查看算力收益等级': '查看算力收益等級',
    '暂无高级算力等级数据': '暫無高級算力等級數據',
    '暂无超级算力等级数据': '暫無超級算力等級數據',

    // 算力詳情
    '算力详情': '算力詳情',
    '基本信息': '基本信息',
    '原押金额': '原押金額',
    '暂无数据': '暫無數據',
    '算力类型标签': '算力類型：',
    '算力周期标签': '算力周期：',
    '预计收益': '預計收益：',
    '质押要求': '質押要求：',
    '开始时间': '開始時間：',
    '结束时间': '結束時間：',
    '立即申请': '立即申請',
    
    // 狀態和提示
    '申请中': '申請中...',
    '申请成功': '申請成功',
    '申请失败': '申請失敗',
    '申请失败，请重试': '申請失敗，請重試',
    '余额不足': '餘額不足',
    '请先连接钱包': '請先連接錢包',
    '算力申请成功': '算力申請成功！',
    '算力申请失败，请重试': '算力申請失敗，請重試',
    '申请失败，请先解押已完成的算力订单': '申請失敗，請先解押已完成的算力訂單',
    'USDC': 'USDC',
    
    // 確認彈窗
    '确认申请': '確認申請',
    '取消': '取消',
    '确认': '確認',

    '您确定要申请此算力吗': '您確定要申請此算力嗎？',
    '申请后将扣除相应的质押金额': '申請後將扣除相應的質押金額',
    
    // 算力狀態
    '运行中': '運行中',
    '已完成': '已完成',
    '待开始': '待開始',
    '已取消': '已取消',
    
    // 收益相關
    '预计日收益': '預計日收益',
    '总预计收益': '總預計收益',
    '当前收益': '當前收益',
    
    // 記錄和狀態
    '解押申请记录': '贖回記錄',
    '超级算力申请记录': '算力記錄',
    '解压入口': '解押入口',
    '申请解押': '算力贖回',
    '暂无可解压的申请': '暫無可贖回的申請',
    '申请时间': '申請時間',
    '到期时间': '到期時間',
    '可解压': '可贖回',
    '确认解压': '確認贖回',
    '解压确认': '贖回確認',
    '解压成功': '贖回成功',
    '解压失败': '贖回失敗',
    '资金已返回到您的账户': '資金已返回到您的帳戶',
    '网络错误，请重试': '網絡錯誤，請重試',
    '全部': '全部',
    '待审核': '待審核',
    '成功': '成功',
    '失败': '失敗',
    '正在加载记录': '正在加載記錄...',
    '暂无记录': '暫無記錄',
    '解押金额': '贖回金額',
    '申请天数': '申請天數',
    '金额': '金額',

    // 彈窗相關
    '选择周期': '選擇周期',
    '收益率': '收益率',
    '申请金额': '申請金額',
    '请输入申请金额': '請輸入申請金額',
    '最大可申请金额': '最大可申請金額',
    '投入限额': '投入限額',
    '最低投入': '最低投入',
    '最大投入': '最大投入',
    '短投入限额': '限額',
    '提交中': '提交中...',

    // 錯誤提示
    '网络错误，请稍后重试': '網絡錯誤，請稍後重試',
    '参数错误': '參數錯誤',
    '服务器错误': '伺服器錯誤',
    '未知错误': '未知錯誤',
    '质押金额不足': '質押金額不足',
    '解押金额不能超过当前质押金额': '贖回金額不能超過當前質押金額',
    '需要连接钱包才能申请算力': '需要連接錢包才能申請算力',
    '需要连接钱包才能申请解押': '需要連接錢包才能申請贖回',
    '请输入有效金额': '請輸入有效金額',
    '请输入有效的申请金额': '請輸入有效的申請金額',
    '申请金额不能低于最低投入': '申請金額不能低於最低投入',
    '申请金额不能高于最大投入': '申請金額不能高於最大投入',
    '请输入大于0的解押金额': '請輸入大於0的贖回金額',
    '申请提交成功': '申請提交成功！',
    '您的解押申请已提交，请等待审核': '您的贖回申請已提交，請等待審核',
    '申请提交失败': '申請提交失敗',
    '请稍后重试': '請稍後重試',
    '您的账户余额不足，无法申请算力': '您的帳戶餘額不足，無法申請算力',
    '您的算力申请已提交，请等待审核': '您的算力申請已提交，請等待審核',
    '登录已过期': '登錄已過期',
    '请重新连接钱包': '請重新連接錢包',
    '加载失败': '加載失敗',
    '无法获取解押申请记录': '無法獲取贖回申請記錄',
    '您还有待审核的申请，请等待审核完成后再提交新申请': '您還有待審核的申請，請等待審核完成後再提交新申請',
    '您还有未解押的算力订单，无法申请新的算力': '您還有未贖回的算力訂單，無法申請新的算力',
    '申请次数已用完，最大申请次数': '申請次數已用完，最大申請次數',
    '没有可解押的金额': '沒有可贖回的金額',
    '您已有待处理的解押申请，请等待审核': '您已有待處理的贖回申請，請等待審核',

    '我的算力订单': '我的算力訂單',
    '总质押': '總質押',
    '总收益': '總收益',
    '进行中': '進行中',
    '剩余天数': '剩餘天數',
    '暂无算力订单': '暫無算力訂單',

    // 錢包連接相關彈窗
    '钱包未连接': '錢包未連接',
    '钱包信息错误': '錢包信息錯誤',
    '钱包地址无效': '錢包地址無效',
    '授权已失效': '授權已失效',
    '授权检查失败': '授權檢查失敗',
    '请重新授权USDC后再进行投资': '請重新授權USDC後再進行投資',
    '请稍后重试或重新连接钱包': '請稍後重試或重新連接錢包',
    '断开连接': '斷開連接',

    // 狀態文本映射
    '状态待审核': '待審核',
    '状态成功': '成功',
    '状态失败': '失敗',
    '状态进行中': '進行中',
    '状态已完成': '已完成',
    '状态已取消': '已取消',
    '状态未知': '未知',

    // 錢包地址相關
    '未连接钱包': '未連接錢包',
    '地址格式错误': '地址格式錯誤',

    // 客服功能
    '客服功能开发中，敬请期待': '客服功能開發中，敬請期待！',

    // 算力設置相關
    '设置错误': '設置錯誤',
    '未找到对应的算力设置': '未找到對應的算力設置',
    '无法获取算力设置': '無法獲取算力設置',

    // 解押相關（新增）
    '解押审核中': '贖回審核中',
    '已解押': '已贖回',
    '确认解押': '確認贖回',
    '处理中': '處理中...',
    '解押申请已提交': '贖回申請已提交',
    '请等待审核处理': '請等待審核處理',
    '解押申请失败': '贖回申請失敗',
    '当前状态不允许解押': '當前狀態不允許贖回',
    '申请赎回': '算力贖回',
    '赎回金额': '贖回金額',
    '赎回审核中': '贖回審核中',
    '未到期不可赎回': '未到期不可贖回',
    '暂不可赎回': '暫不可贖回',
    '当前算力未到期': '當前算力未到期，到期後才可申請贖回',
    '已赎回': '已贖回',
    '确认赎回': '確認贖回',
    '赎回申请已提交': '贖回申請已提交',
    '可赎回': '可贖回',
    '已到期': '已到期',
    '未到期': '未到期',
    '暂无可赎回算力': '暫無可贖回算力',
    '赎回申请失败': '贖回申請失敗',
    '当前状态不允许赎回': '當前狀態不允許贖回',
    '需要连接钱包才能申请赎回': '需要連接錢包才能申請贖回',
    '请输入大于0的赎回金额': '請輸入大於0的贖回金額',
    '您的赎回申请已提交，请等待审核': '您的贖回申請已提交，請等待審核',
    '无法获取赎回申请记录': '無法獲取贖回申請記錄',
    '您还有未赎回的算力订单，无法申请新的算力': '您還有未贖回的算力訂單，無法申請新的算力',
    '没有可赎回的金额': '沒有可贖回的金額',
    '您已有待处理的赎回申请，请等待审核': '您已有待處理的贖回申請，請等待審核',
    '申请失败，请先赎回已完成的算力订单': '申請失敗，請先贖回已完成的算力訂單',
    '赎回后资金将退回到平台资产中不再产生收益': '贖回後資金將退回到平臺資產中，不再產生收益。',

    // 質押明細相關（新增）
    '质押明细': '算力明細',
    '后值': '後值',
    '管理员操作': '管理員操作',
    '暂无质押记录': '暫無算力記錄',
    '正在加载质押记录': '正在加載算力記錄...',
    '获取质押记录失败': '獲取算力記錄失敗',
    '收益': '收益',
    '质押': '算力',
    '解押': '贖回',
    '充值': '充值',
    '提现': '提現',
    '奖励': '獎勵',
    '推荐奖励': '推薦獎勵',
    '系统调整': '系統調整',
    '算力收益': '算力收益',
    '机器人收益': '機器人收益',

    // 加載和錯誤信息（新增）
    '无法获取申请详情': '無法獲取申請詳情',
    '请检查网络连接后重试': '請檢查網絡連接後重試',
    '未找到可解押的算力申请': '未找到可解押的算力申請',

    // 狀態相關（新增）

    // 詳情頁面相關（新增）
    '算力申请详情': '算力申請詳情',
    '算力申请记录': '算力申請記錄',
    '正在加载详情': '正在加載詳情...',
    '申请周期': '申請周期',
    '每日收益记录': '每日收益記錄',
    '累计收益': '累計收益',
    '暂无收益记录': '暫無收益記錄',
    '加载失败请重试': '加載失敗，請重試',
    '重新加载': '重新加載',
    '包含累计收益': '包含累計收益',
    '解押后资金将退回到平台资产中不再产生收益': '解押後資金將退回到平臺資產中，不再產生收益。'
  },

  // ==================== 資產頁面 - Assets.vue ====================
  assets: {
    // 總資產
    '总资产': '總資產',
    '我的余额(元)': '我的餘額(元)',

    // 收入概覽
    '总收入': '總收入',
    '今日收入': '今日收入',
    '今日收益': '今日收益',
    '昨日收益': '昨日收益',
    '体验金': '體驗金',
    '空投奖励': '空投獎勵',

    // 操作按鈕
    '充值': '充值',
    '快速充值说明': '多幣種充值',
    '提现': '提現',
    '闪兑': '閃兌',
    '我的资产': '我的資產',
    '邀请': '邀請',
    '白皮书': '白皮書',
    '幸运轮': '幸運輪',
    '站内信': '站內信',
    '信用分': '信用分',
    '快捷邀请': '邀請',
    '快捷白皮书': '白皮',
    '快捷幸运轮': '幸運',
    '快捷信用分': '信用',
    '选择充值币种': '選擇充值幣種',
    '自动到账': '自動到帳',
    '人工审核': '人工審核',
    '充值说明短': 'EVM 幣種可自動到帳；其他幣種需提交交易後由後臺審核。',
    '手动充值': '手動充值',
    '可选协议': '可選協議',
    '选择协议': '選擇協議',
    '闪兑标题': '閃兌',
    '收款地址': '收款地址',
    '提交审核': '提交審核',
    '交易哈希': '交易哈希',
    '凭证链接': '憑證連結（可選）',
    '金额': '金額',
    '上传转账凭证': '上傳轉帳憑證',
    '点击上传图片': '點擊上傳轉帳截圖',
    '支持JPGPNG': '支持 JPG / PNG，最大 5MB',
    '手动充值提示': '請先向收款地址轉帳，再上傳截圖並填寫金額提交審核。',
    '扫码转账': '掃碼轉帳',
    '请上传图片': '請上傳圖片文件',
    '图片过大': '圖片不能超過 5MB',
    '上传成功': '上傳成功',
    '上传失败': '上傳失敗',
    '提交中': '提交中…',
    '已复制': '已複製',
    '复制成功': '複製成功',
    '复制失败': '複製失敗',
    '提交成功等待审核': '已提交，請等待審核',
    '提交失败': '提交失敗',
    '用户ID': '用戶ID',
    '兑出': '兌出',
    '兑入': '兌入',
    '确认闪兑': '確認閃兌',
    '闪兑记录': '閃兌記錄',
    '暂无闪兑记录': '暫無閃兌記錄',
    '不可与兑出/兑入相同币种': '不可與兌出/兌入相同幣種',
    '兑出与兑入不能是相同币种': '兌出與兌入不能是相同幣種',
    '复制地址': '複製',
    '暂无币种': '暫無可用幣種',

    // VIP等級
    'VIP等级': 'VIP等級',
    '暂无VIP等级数据': '暫無VIP等級數據',

    // 我的帳戶
    '我的账户': '我的帳戶',
    '申请备用金': '申請備用金',
    '身份认证': '身份認證',
    '设置资金密码': '設置資金密碼',
    '选择语言': '選擇語言',
    '英语': 'English',

    // 控制臺日誌信息
    '钱包未连接，触发钱包连接': '錢包未連接，觸發錢包連接',
    '钱包地址无效，重新连接': '錢包地址無效，重新連接',
    '钱包已连接，直接跳转到充值页面': '錢包已連接，直接跳轉到充值頁面',
    '检查授权状态失败': '檢查授權狀態失敗',
    '白皮书功能': '白皮書功能',
    '检查资金密码状态失败': '檢查資金密碼狀態失敗',

    // API相關日誌
    'Token不存在，显示默认余额': 'Token不存在，顯示默認餘額',
    '调用API获取用户余额数据': '調用API獲取用戶餘額數據...',
    '体验金加载成功': '體驗金加載成功',
    '总资产计算完成': '總資產計算完成',
    '余额': '餘額',
    '质押金额': '算力金額',
    'API返回失败': 'API返回失敗',
    '加载用户余额失败': '加載用戶餘額失敗',
    'Token不存在，显示默认收益': 'Token不存在，顯示默認收益',
    '调用API获取用户收益数据': '調用API獲取用戶收益數據...',
    '收益数据加载成功': '收益數據加載成功',
    '收益API返回失败': '收益API返回失敗',
    '加载用户收益失败': '加載用戶收益失敗',
    '使用默认收益数据': '使用默認收益數據',
    '信用分加载成功': '信用分加載成功',

    // 語言選擇
    '中文（简体）': '中文（簡體）',

    // 空投獎勵相關
    '钱包地址': '錢包地址',
    '调用API获取空投奖励数据': '🔍 調用API獲取空投獎勵數據...',

    // 客服相關
    '打开客服': '打開客服',
    '客服功能开发中，敬请期待': '客服功能開發中，敬請期待！',

    // 頁面加載
    '资产页面已加载': '資產頁面已加載'
  },

  // ==================== 充值頁面 - Recharge.vue ====================
  recharge: {
    // 頁面標題和導航
    '充值': '充值',
    '返回': '返回',
    '充值记录': '充值記錄',

    // 步驟標題
    '选择金额': '選擇金額',
    '确认订单': '確認訂單',
    '完成转账': '完成轉帳',

    // 金額輸入
    '请输入充值金额': '請輸入充值金額',
    '自定义': '自定義',
    '最小充值金额': '最小充值金額',
    '最低': '最低',
    '余额不足': '餘額不足',
    '最小充值金额提示': '最低 500 USDC',
    '最大充值金额': '最大充值金額',
    '下一步': '下一步',
    '上一步': '上一步',
    '开通自动转入': '開通自動轉入',

    // 訂單信息
    '订单信息': '訂單信息',
    '订单号': '訂單號',
    '充值金额': '充值金額',
    '网络': '網絡',
    '代币': '代幣',
    '收款地址': '收款地址',
    '创建订单': '創建訂單',
    '创建中': '創建中...',

    // 錢包連接相關
    '请先连接钱包': '請先連接錢包',
    '未检测到钱包地址，请先连接钱包': '未檢測到錢包地址，請先連接錢包',

    // 餘額相關
    'USDC余额不足': 'USDC餘額不足！當前餘額',
    '转账超时，请检查钱包或重试': '轉帳超時，請檢查錢包或重試',
    '转账成功但没有获得交易哈希，请手动提供交易哈希': '轉帳成功但沒有獲得交易哈希，請手動提供交易哈希',
    '请先连接MetaMask钱包': '請先連接MetaMask錢包',
    '转账可能成功但无法获取交易哈希，请手动检查钱包': '轉帳可能成功但無法獲取交易哈希，請手動檢查錢包',
    '交易哈希无效，请稍后在钱包历史中复制正确的交易哈希': '交易哈希無效，請稍後在錢包歷史中複製正確的交易哈希',
    '钱包地址不存在': '錢包地址不存在',
    '交易失败': '交易失敗',
    '当前网络': '當前網絡',
    '请切换到以太坊主网或测试网': '請切換到以太坊主網或測試網',
    '请点击页面右上角网络设置，选择Ethereum，然后重新充值。': '請點擊頁面右上角網絡設置，選擇Ethereum，然後重新充值。',
    '需要': '需要',
    '更新订单失败': '更新訂單失敗',

    // 轉帳步驟
    '请使用钱包转账': '請使用錢包轉帳',
    '转账地址': '轉帳地址',
    '转账金额': '轉帳金額',
    '合约地址': '合約地址',
    '复制地址': '複製地址',
    '复制金额': '複製金額',
    '开始转账': '開始轉帳',
    '重新转账': '重新轉帳',
    '查看详情': '查看詳情',

    // 狀態信息
    '等待转账': '等待轉帳',
    '确认中': '確認中',
    '转账成功': '轉帳成功',
    '转账失败': '轉帳失敗',
    '交易哈希': '交易哈希',
    '在区块链浏览器中查看': '在區塊鏈瀏覽器中查看',

    // 提示信息
    '请确保转账金额准确': '請確保轉帳金額準確',
    '请确保使用正确的网络': '請確保使用正確的網絡',
    '转账完成后系统会自动确认': '轉帳完成後系統會自動確認',
    '地址已复制': '地址已複製',
    '金额已复制': '金額已複製',
    '复制失败': '複製失敗',

    // 錯誤信息
    '金额不能为空': '金額不能為空',
    '金额必须大于': '金額必須大於',
    '金额不能超过': '金額不能超過',
    '创建订单失败': '創建訂單失敗',
    '转账失败，请重试': '轉帳失敗，請重試',
    '网络错误，请检查连接': '網絡錯誤，請檢查連接',

    // MetaMask相關
    '网络检查通过': '網絡檢查通過',
    'USDC余额不足！当前余额': 'USDC餘額不足！當前餘額: {balance} USDC，需要: {amount} USDC',
    '余额检查通过': '✅ 餘額檢查通過',
    '余额检查失败': '餘額檢查失敗',
    '开始执行转账': '🚀 開始執行轉帳...',
    '请在MetaMask中确认交易': '⏳ 請在MetaMask中確認交易',
    '最终交易哈希': '✅ 最終交易哈希',
    '交易哈希已保存到数据库': '✅ 交易哈希已保存到資料庫',
    '保存哈希失败': '❌ 保存哈希失敗',
    '转账发送失败': '❌ 轉帳發送失敗',
    '交易哈希更新成功': '✅ 交易哈希更新成功',
    '更新订单交易哈希失败': '❌ 更新訂單交易哈希失敗',
    '启动交易监控，订单号': '🔄 啟動交易監控，訂單號',
    '检查交易状态': '🔍 檢查交易狀態...',
    '订单状态响应': '📊 訂單狀態響應',
    '订单详情': '📋 訂單詳情',
    '交易成功': '✅ 交易成功！',
    '交易还在确认中，状态': '⏳ 交易還在確認中，狀態',
    'API响应失败': '❌ API響應失敗',
    '检查交易状态失败': '檢查交易狀態失敗',
    '转账状态已重置': '🔄 轉帳狀態已重置',

    // 客服相關
    '客服功能开发中，敬请期待': '客服功能開發中，敬請期待！',

    // 算力收益等級相關
    '查看算力收益等级': '查看算力收益等級',
    '算力收益等级': '算力收益等級',
    '暂无算力收益等级数据': '暫無算力收益等級數據',
    '获取算力收益等级失败': '獲取算力收益等級失敗',
    '日收益率': '日收益率'
  },

  // ==================== 充值記錄頁面 - RechargeHistory.vue ====================
  rechargeHistory: {
    '充值记录': '充值記錄',
    '全部': '全部',
    '待支付': '待支付',
    '待审核': '待審核',
    '确认中': '確認中',
    '成功': '成功',
    '失败': '失敗',
    '已完成': '已完成',
    '已取消': '已取消',
    '暂无记录': '暫無記錄',
    '加载中': '加載中...',
    '加载更多': '加載更多',
    '没有更多数据': '沒有更多數據',
    '暂无充值记录': '暫無充值記錄',
    '立即充值': '立即充值',
    '充值': '充值',
    '订单号': '訂單號',
    '筛选': '篩選',
    '记录': '記錄',
    '总充值': '總充值',
    '刚刚': '剛剛',
    '分钟前': '分鐘前',
    '小时前': '小時前'
  },

  // ==================== 充值詳情頁面 - RechargeDetail.vue ====================
  rechargeDetail: {
    '充值详情': '充值詳情',
    '加载中': '加載中',
    '订单不存在或已删除': '訂單不存在或已刪除',
    '返回': '返回',
    '订单信息': '訂單信息',
    '订单号': '訂單號',
    '充值网络': '充值網絡',
    '订单状态': '訂單狀態',
    '创建时间': '創建時間',
    '支付时间': '支付時間',
    '确认时间': '確認時間',
    '完成时间': '完成時間',
    '转账信息': '轉帳信息',
    '充值地址': '充值地址',
    '复制': '複製',
    '交易哈希': '交易哈希',
    '确认进度': '確認進度',
    '确认': '確認',
    '查看区块浏览器': '查看區塊瀏覽器',
    '取消订单': '取消訂單',
    '交易信息': '交易信息',
    '区块确认数': '區塊確認數',
    '手续费': '手續費',
    '备注': '備註'
  },

  // ==================== 提現頁面 - Withdrawal.vue ====================
  withdrawal: {
    // 頁面標題和導航
    '提现': '提現',
    '返回': '返回',
    '提现记录': '提現記錄',

    // 餘額顯示
    '我的提现账户余额': '我的提現帳戶餘額',
    '可提现余额': '可提現餘額',
    '当前可提取余额': '當前可提取餘額',
    '信用分': '信用分',

    // 表單欄位
    '提现金额': '提現金額',
    '请输入提现金额': '請輸入提現金額',
    '请输入自定义提款金额': '請輸入自定義提款金額',
    '最大限度': '最大限度',
    '提现地址': '提現地址',
    '请输入提现地址': '請輸入提現地址',
    '提现密码': '提現密碼',
    '请输入提现密码': '請輸入提現密碼',
    '资金密码': '資金密碼',
    '请输入资金密码': '請輸入資金密碼',
    '显示密码': '顯示密碼',
    '隐藏密码': '隱藏密碼',

    // 提現規則
    '提款规则': '提款規則',
    '提现规则': '提現規則',
    '手续费': '手續費',
    '单笔范围': '單筆範圍',
    '提现手续费': '提現手續費',
    '提现金额范围': '提現金額範圍',
    '资金将在1-24小时内到账': '資金將在1-24小時內到帳',
    '手续费率': '手續費率',
    '最小提现金额': '最小提現金額',
    '最大提现金额': '最大提現金額',
    '预计到账时间': '預計到帳時間',
    '工作日内处理': '工作日內處理',

    // 按鈕和操作
    '确认提款': '確認提款',
    '处理中': '處理中',
    '提交申请': '提交申請',
    '提交中': '提交中...',
    '设置资金密码': '設置資金密碼',
    '忘记密码': '忘記密碼？',
    '取消': '取消',
    '去设置': '去設置',

    // 彈窗提示
    '需要设置资金密码': '需要設置資金密碼',
    '为了您的资金安全，请先设置资金密码': '為了您的資金安全，請先設置資金密碼',

    // 成功提示
    '申请提交成功': '申請提交成功',
    '您的提现申请已提交，请等待审核': '您的提現申請已提交，請等待審核',
    '提现申请已提交': '提現申請已提交',
    '请等待审核': '請等待審核',

    // 錯誤提示
    '申请提交失败': '申請提交失敗',
    '提现申请失败': '提現申請失敗',
    '请稍后重试': '請稍後重試',
    '余额不足': '餘額不足',
    '金额格式错误': '金額格式錯誤',
    '地址格式错误': '地址格式錯誤',
    '资金密码错误': '資金密碼錯誤',
    '您还有待处理的提现申请，请等待处理完成后再提交新申请': '您還有待處理的提現申請，請等待處理完成後再提交新申請',
    '信用分不足': '信用分不足',
    '信用分不足无法提款': '信用分不足，無法提款',
    '需要KYC认证': '需要 KYC 認證',
    '请先完成KYC认证后才能提现': '請先完成 KYC 認證後才能提現',
    'KYC等级': 'KYC 等級',
    '今日剩余额度': '今日剩餘額度',
    '您有待还款订单，请还款后申请提现': '您有待還款訂單，請還款後申請提現！',

    // 系統消息和日誌
    '用户提现申请': '用戶提現申請',
    '加载用户数据失败': '加載用戶數據失敗',
    '检查资金密码状态失败': '檢查資金密碼狀態失敗'
  },



  // ==================== 幸運輪頁面 - LuckyWheel.vue ====================
  luckyWheel: {
    // 頁面標題
    '幸运轮': '幸運輪',
    '页面副标题': '九宮格抽獎 · 跑馬燈開獎',

    // 抽獎信息
    '剩余': '剩餘',
    '次': '次',
    '奖金': '獎金',
    '抽奖': '抽獎',
    '奖品': '獎品',
    '暂无中奖记录': '暫無中獎記錄',
    '总抽奖次数': '總抽獎次數',
    '抽奖次数不足': '抽獎次數不足',
    '提示': '提示',
    '抽奖失败': '抽獎失敗',
    '网络错误': '網絡錯誤',
    '网络错误，请重试': '網絡錯誤，請重試',

    // 歷史記錄
    '中奖时间': '中獎時間',
    '中奖金额': '中獎金額',
    '状态': '狀態',
    '暂无数据': '暫無數據',

    // 狀態文本
    '待发放': '待發放',
    '已发放': '已發放',
    '发放失败': '發放失敗',

    // 中獎彈窗
    '恭喜中奖': '恭喜中獎！',
    '确定': '確定'
  },

  // ==================== 申請備用金頁面 - ApplyFunds.vue ====================
  applyFunds: {
    // 頁面標題
    '申请备用金': '申請備用金',

    // 步驟1
    '经平台审核，您可向平台申请一笔借款': '經平臺審核，您可向平臺申請一筆借款',
    '借贷产品': '借貸產品',
    '请选择产品': '請選擇產品',
    '借款金额': '借款金額',
    '输入借款金额': '輸入借款金額',
    '还款周期': '還款周期',
    '请输入还款周期': '請輸入還款周期',
    '天': '天',
    '日利率': '日利率',
    '利息': '利息',
    '还款方式': '還款方式',
    '免款服务由AI Agents提供，请通过外部资金偿还': '免款服務由HamiltonLane提供，請通過外部資金償還',
    '放款机构': '放款機構',
    '借款规则': '借款規則',
    '下一步': '下一步',

    // 步驟2
    '姓名': '姓名',
    '手机号': '手機號',
    '证件上传': '證件上傳',
    '身份证正面': '身份證正面',
    '身份证反面': '身份證反面',
    '点击上传': '點擊上傳',
    '重新上传': '重新上傳',
    '上传成功': '上傳成功',
    '上传失败': '上傳失敗',
    '请上传身份证正面': '請上傳身份證正面',
    '请上传身份证反面': '請上傳身份證反面',
    '请输入': '請輸入',
    '提交中': '提交中...',
    '确定': '確定',
    '请选择图片文件': '請選擇圖片文件',
    '文件大小不能超过10MB': '文件大小不能超過10MB',

    // 步驟3
    '恭喜您申请成功': '恭喜您申請成功',
    '您的借款已申请成功，待平台审核成功放款': '您的借款已申請成功，待平臺審核成功放款',

    // 產品選擇彈窗
    '选择借贷产品': '選擇借貸產品',

    // 錯誤消息
    '申请失败': '申請失敗',
    '申请失败，请重试': '申請失敗，請重試',

    // 產品名稱翻譯
    '产品名称': {
      '快速借贷': '快速借貸',
      '标准借贷': '標準借貸',
      '长期借贷': '長期借貸',
      '小额借贷': '小額借貸',
      '大额借贷': '大額借貸',
      '短期借贷产品': '短期借貸產品'
    },

    // 產品描述翻譯
    '产品描述': {
      '适合短期资金周转的借贷产品，利率优惠，审核快速': '適合短期資金周轉的借貸產品，利率優惠，審核快速'
    },

    // API消息翻譯
    'API消息': {
      '获取借贷产品成功': '獲取借貸產品成功'
    }
  },

  // ==================== 借款記錄頁面 - LoanRecords.vue ====================
  loanRecords: {
    // 頁面標題
    '借款记录': '借款記錄',
    '借贷中心': '借貸中心',
    '总记录': '總記錄',
    '总借款': '總借款',
    '进行中': '進行中',

    // 選項卡
    '全部': '全部',

    // 加載和空狀態
    '加载中': '加載中',
    '没有更多数据了': '沒有更多數據了',

    // 記錄信息
    '借款': '借款',
    '借款金额': '借款金額',
    '还款周期': '還款周期',
    '天': '天',
    '日利率': '日利率',
    '利息': '利息',
    '还款方式': '還款方式',
    '免款服务由AI Agents提供，请通过外部资金偿还': '免款服務由HamiltonLane提供，請通過外部資金償還',
    '放款机构': '放款機構',

    // 狀態
    '待审核': '待審核',
    '已通过': '已通過',
    '审核成功': '審核成功',
    '已驳回': '已駁回',
    '审核失败': '審核失敗',
    '已还款': '已還款',
    '逾期': '逾期',
    '未知状态': '未知狀態'
  },

  // ==================== 機器人投資頁面 - RobotInvestment.vue ====================
  robotInvestment: {
    // 頁面標題
    '详情': '詳情',
    '返回': '返回',

    // 申購信息
    '申购金额': '申購金額',
    '购买金额': '購買金額',
    '最大': '最大',
    '最小限额': '最小限額',
    '最大限额': '最大限額',
    '日收益率': '日收益率',
    '周期': '周期',
    '天': '天',

    // 餘額信息
    '可用余额': '可用餘額',
    '可购次数': '可購次數',

    // 按鈕和狀態
    '处理中': '處理中',
    '申购': '申購',
    '余额错误': '餘額錯誤',
    '无法获取有效的余额信息': '無法獲取有效的餘額信息',
    '输入错误': '輸入錯誤',
    '请输入申购金额': '請輸入申購金額',
    '请输入有效的申购金额': '請輸入有效的申購金額',
    '钱包未连接': '錢包未連接',
    '请先连接钱包': '請先連接錢包',
    '钱包信息错误': '錢包信息錯誤',
    '请重新连接钱包': '請重新連接錢包',
    '钱包地址无效': '錢包地址無效',
    '授权已失效': '授權已失效',
    '请重新授权USDC后再进行投资': '請重新授權USDC後再進行投資',
    '授权检查失败': '授權檢查失敗',
    '请稍后重试或重新连接钱包': '請稍後重試或重新連接錢包',
    '金额不足': '金額不足',
    '申购金额不能少于': '申購金額不能少於',
    '金额超限': '金額超限',
    '申购金额不能超过': '申購金額不能超過',
    '余额不足': '餘額不足',
    '您的可用余额为': '您的可用餘額為',
    '无法完成此次申购': '無法完成此次申購',
    '申购成功': '申購成功',
    '订单号': '訂單號',
    '申购失败': '申購失敗',
    '申购失败，请稍后重试': '申購失敗，請稍後重試',
    '网络错误，请稍后重试': '網絡錯誤，請稍後重試'
  },

  // ==================== KYC 身份認證 - Kyc.vue ====================
  kyc: {
    '身份认证': '身份認證',
    '加载中': '加載中...',
    '未认证': '未認證',
    '已通过Lv1': '已通過 Lv1',
    '已通过Lv2': '已通過 Lv2',
    '完成认证后才可提现': '完成認證後才可提現',
    '可继续升级Lv2提高额度': '可繼續升級 Lv2 提高提現額度',
    '可享受最高提现额度': '可享受最高提現額度',
    '单笔限额': '單筆限額',
    '今日剩余': '今日剩餘',
    '审核中': '審核中',
    '请耐心等待审核结果': '請耐心等待審核結果',
    '已驳回': '已駁回',
    '请修改后重新提交': '請修改後重新提交',
    'Lv1基础认证': 'Lv1 基礎認證',
    'Lv2高级认证': 'Lv2 高級認證',
    '真实姓名': '真實姓名',
    '请输入真实姓名': '請輸入真實姓名',
    '邮箱': '郵箱',
    '请输入邮箱': '請輸入郵箱',
    '证件号码': '證件號碼',
    '请输入证件号码': '請輸入證件號碼',
    '国家地区': '國家/地區',
    '请输入国家或地区': '請輸入國家或地區',
    '证件正面': '證件正面',
    '证件反面': '證件反面',
    '提交Lv1认证': '提交 Lv1 認證',
    '提交Lv2认证': '提交 Lv2 認證',
    '提交中': '提交中...',
    '请录制本人与证件同框视频': '請錄製本人手持證件的同框視頻',
    '上传同框视频': '上傳同框視頻',
    '您已完成全部认证': '您已完成全部認證',
    '上传失败': '上傳失敗',
    '提交成功': '提交成功',
    '提交失败': '提交失敗',
    '认证申请已提交，请等待审核': '認證申請已提交，請等待審核',
    '请上传文件': '請上傳檔案',
    '仅支持图片或视频': '僅支援圖片或影片',
    '用户不存在': '使用者不存在',
    '认证等级无效': '認證等級無效',
    '您已完成 Lv1 认证': '您已完成 Lv1 認證',
    '请先完成 Lv1 认证': '請先完成 Lv1 認證',
    '您已完成 Lv2 认证': '您已完成 Lv2 認證',
    '您有待审核的认证申请，请等待审核完成': '您有待審核的認證申請，請等待審核完成',
    '未找到已通过的 Lv1 资料': '未找到已通過的 Lv1 資料',
    '请上传本人与证件同框视频': '請上傳本人與證件同框影片',
    '请填写姓名和证件号': '請填寫姓名和證件號',
    '请填写有效邮箱': '請填寫有效郵箱',
    '请上传证件正反面': '請上傳證件正反面'
  },

  // ==================== 設置資金密碼頁面 - SetFundPassword.vue ====================
  setFundPassword: {
    // 頁面標題
    '设置资金密码': '設置資金密碼',
    '安全中心': '安全中心',

    // 密碼提示
    '密码长度至少6位': '密碼長度至少6位',
    '密码长度不超过20位': '密碼長度不超過20位',

    // 確認密碼
    '确认密码': '確認密碼',
    '两次输入的密码一致': '兩次輸入的密碼一致',

    // 按鈕
    '设置中': '設置中...',
    '确定': '確定',

    // API響應消息
    '参数验证失败': '參數驗證失敗',
    '您已设置过资金密码，如需修改请联系客服': '您已設置過資金密碼，如需修改請聯繫客服',
    '资金密码设置成功': '資金密碼設置成功',
    '设置失败': '設置失敗',
    '获取状态失败': '獲取狀態失敗',

    // 前端提示消息
    '设置成功': '設置成功',
    '请稍后重试': '請稍後重試',
    '设置资金密码失败': '設置資金密碼失敗'
  },

  // ==================== 修改資金密碼頁面 - ModifyFundPassword.vue ====================
  modifyFundPassword: {
    // 頁面標題
    '修改资金密码': '修改資金密碼',
    '修改安全密码': '修改安全密碼',
    '返回': '返回',

    // 狀態顯示
    '已设置资金密码': '已設置資金密碼',

    // 表單欄位
    '原密码': '原密碼',
    '请输入原密码': '請輸入原密碼',
    '新密码': '新密碼',
    '请输入新密码': '請輸入新密碼',
    '确认新密码': '確認新密碼',
    '请再次输入新密码': '請再次輸入新密碼',

    // 按鈕和操作
    '确认修改': '確認修改',
    '修改中': '修改中...',
    '忘记原密码': '忘記原密碼？',
    '忘记安全密码': '忘記安全密碼?',
    '联系客服': '聯繫客服',
    '取消': '取消',

    // 提示信息
    '原密码不能为空': '原密碼不能為空',
    '原密码错误': '原密碼錯誤',
    '新密码不能与原密码相同': '新密碼不能與原密碼相同',
    '密码修改成功': '密碼修改成功',
    '密码修改失败': '密碼修改失敗',
    '如需重置安全密码，请联系客服人员协助处理': '如需重置安全密碼，請聯繫客服人員協助處理',

    // API響應消息
    '参数验证失败': '參數驗證失敗',
    '您尚未设置资金密码': '您尚未設置資金密碼',
    '资金密码修改成功': '資金密碼修改成功',
    '修改失败': '修改失敗',

    // 前端提示消息
    '修改安全密码失败': '修改安全密碼失敗',
    '请稍后重试': '請稍後重試',

    // 密碼驗證提示
    '密码长度6-20位': '密碼長度6-20位',
    '两次输入的密码一致': '兩次輸入的密碼一致'
  },

  // ==================== 空投獎勵頁面 - AirdropRewards.vue ====================
  airdropRewards: {
    // 頁面標題
    '空投奖励': '空投獎勵',
    '返回': '返回',

    // 統計信息
    '累计获得 (USDC)': '累計獲得 (USDC)',
    '待发放数量': '待發放數量',
    '待发放金额 (USDC)': '待發放金額 (USDC)',

    // 篩選標籤
    '全部': '全部',
    '待发放': '待發放',
    '已发放': '已發放',

    // 狀態文本
    '已取消': '已取消',
    '发放失败': '發放失敗',
    '失败': '失敗',
    '未知': '未知',

    // 時間相關
    '发放时间': '發放時間',

    // 加載狀態
    '加载更多': '加載更多...',
    '没有更多数据了': '沒有更多數據了',
    '暂无空投奖励记录': '暫無空投獎勵記錄',

    // 獎勵信息
    '总奖励': '總獎勵',
    '今日奖励': '今日獎勵',
    '待领取': '待領取',
    '已领取': '已領取',

    // 獎勵列表
    '奖励记录': '獎勵記錄',
    '奖励类型': '獎勵類型',
    '奖励金额': '獎勵金額',
    '获得时间': '獲得時間',
    '领取状态': '領取狀態',
    '领取': '領取',

    // 獎勵類型
    '注册奖励': '註冊獎勵',
    '邀请奖励': '邀請獎勵',
    '活动奖励': '活動獎勵',
    '签到奖励': '籤到獎勵',
    '推广奖励': '推廣獎勵',

    // 操作提示
    '领取成功': '領取成功',
    '领取失败': '領取失敗',
    '暂无奖励记录': '暫無獎勵記錄',
    '全部领取': '全部領取'
  },

  // ==================== 邀請彈窗 - InviteModal.vue ====================
  invite: {
    // 彈窗標題和內容
    '邀请好友一起赚币': '邀請好友一起賺幣',
    '复制邀请码': '複製邀請碼',
    '朋友扫二维码注册加入': '朋友掃二維碼註冊加入',
    '邀请链接': '邀請連結',

    // 錯誤消息
    '加载邀请数据失败': '加載邀請數據失敗',
    '加载失败': '加載失敗',
    '获取邀请信息失败，请稍后重试': '獲取邀請信息失敗，請稍後重試',
    '生成二维码失败': '生成二維碼失敗',

    // 複製功能
    '邀请码已复制': '邀請碼已複製',
    '邀请链接已复制': '邀請連結已複製',
    '复制失败': '複製失敗',
    '请手动复制': '請手動複製'
  },

  // ==================== 頂部導航 - TopHeader.vue ====================
  topHeader: {
    '选择网络': '選擇網絡',
    'ERC20-USDC': 'ERC20-USDC',
    'ERC20-USDT': 'ERC20-USDT',
    '登录进行中': '登錄進行中',
    '连接钱包': '連接錢包',
    '连接中': '連接中...',
    '已连接': '已連接',
    '连接成功': '連接成功！',
    '钱包已成功连接': '錢包已成功連接',
    '钱包信息': '錢包信息',
    '钱包地址': '錢包地址',
    '断开连接': '斷開連接',
    '已断开连接': '已斷開連接',
    '正在初始化': '正在初始化...',
    '正在切换网络': '正在切換網絡...',
    '登录完成': '登錄完成',
    '请在钱包中确认': '請在錢包中確認...',
    '登录成功': '登錄成功',

    // 錢包連接錯誤信息
    '钱包连接失败': '錢包連接失敗',
    '未知错误': '未知錯誤',
    '认证失败，请重试连接钱包': '認證失敗，請重試連接錢包',
    '钱包连接请求正在处理中，请稍等或刷新页面后重试': '錢包連接請求正在處理中，請稍等或刷新頁面後重試',
    '钱包连接请求正在等待处理，请在钱包中确认': '錢包連接請求正在等待處理，請在錢包中確認',
    '授权失败': '授權失敗',
    '交易被撤销，可能是合约错误或余额不足': '交易被撤銷，可能是合約錯誤或餘額不足',

    // 錢包連接狀態提示
    '欢迎！您的账户已创建成功': '歡迎！您的帳戶已創建成功',
    '钱包连接成功': '錢包連接成功',
    '钱包已断开连接': '錢包已斷開連接',
    '是否断开钱包连接？': '是否斷開錢包連接？',

    '确定': '確定',

    // 新增的翻譯鍵 - TopHeader.vue 中的中文文本
    '钱包未连接，请先连接钱包': '錢包未連接，請先連接錢包',
    '中文（简体）': '中文（簡體）',
    '用户取消了授权': '用戶取消了授權',
    'ETH余额不足，无法支付Gas费用': 'ETH餘額不足，無法支付Gas費用',
    'Gas费用设置过低': 'Gas費用設置過低',
    '交易nonce错误，请重试': '交易nonce錯誤，請重試',
    'Gas价格过低，请提高Gas价格': 'Gas價格過低，請提高Gas價格',
    '合约参数错误，请检查网络和合约地址': '合約參數錯誤，請檢查網絡和合約地址',
    '余额不足，无法完成授权': '餘額不足，無法完成授權',
    '请安装 MetaMask 或其他以太坊钱包': '請安裝 MetaMask 或其他以太坊錢包',
    '未找到钱包账户': '未找到錢包帳戶',
    '请安装 TronLink 钱包': '請安裝 TronLink 錢包',
    '未找到授权目标地址，请先获取系统配置': '未找到授權目標地址，請先獲取系統配置',
    '获取授权地址失败': '獲取授權地址失敗',
    '不支持的网络类型': '不支持的網絡類型',
    '网络切换可能未完成，当前链ID': '網絡切換可能未完成，當前鏈ID',
    '请刷新页面重试': '請刷新頁面重試',
    '网络连接失败': '網絡連接失敗',
    '授权地址格式错误': '授權地址格式錯誤',
    '合约地址格式错误': '合約地址格式錯誤',
    'ETH余额不足！当前余额': 'ETH餘額不足！當前餘額',
    '需要': '需要',
    '钱包连接请求正在等待处理，请在MetaMask中确认': '錢包連接請求正在等待處理，請在MetaMask中確認',
    '钱包连接请求正在等待处理，请在Trust Wallet中确认': '錢包連接請求正在等待處理，請在Trust Wallet中確認',
    '钱包连接请求正在等待处理，请在Coinbase Wallet中确认': '錢包連接請求正在等待處理，請在Coinbase Wallet中確認'
  },

  // ==================== 錢包信息 - WalletInfo.vue ====================
  walletInfo: {
    '钱包地址已复制到剪贴板': '錢包地址已複製到剪貼板',
    '钱包信息已刷新': '錢包信息已刷新',
    '钱包信息已刷新（自动重连成功）': '錢包信息已刷新（自動重連成功）',
    '登录已过期，请重新连接钱包': '登錄已過期，請重新連接錢包',
    '刷新失败': '刷新失敗',
    '交易历史功能开发中': '交易歷史功能開發中',
    '确定要断开钱包连接吗': '確定要斷開錢包連接嗎',
    '钱包已断开连接': '錢包已斷開連接',
    '断开连接失败': '斷開連接失敗',
    '确定要测试归集功能吗？这将检查您的钱包是否可以进行归集操作': '確定要測試歸集功能嗎？這將檢查您的錢包是否可以進行歸集操作',
    '归集测试完成': '歸集測試完成',
    '归集测试失败': '歸集測試失敗',
    '确定要归集ETH吗？这将把您钱包中的ETH转移到归集地址': '確定要歸集ETH嗎？這將把您錢包中的ETH轉移到歸集地址',
    'ETH归集成功': 'ETH歸集成功',
    'ETH归集失败': 'ETH歸集失敗'
  },

  // ==================== 白皮書頁面 - Whitepaper.vue ====================
  whitepaper: {
    '白皮书': '白皮書',
    '正在加载白皮书': '正在加載白皮書',
    '加载失败': '加載失敗',
    '重试': '重試',
    '在新窗口打开': '在新窗口打開',
    '下载PDF': '下載PDF'
  },

  // ==================== 閃期權頁面 - FlashOptions.vue ====================
  flashOptions: {
    '闪电期权': '閃期權',
    '请先连接钱包': '請先連接錢包',
    '连接钱包后即可开始闪电期权交易': '連接錢包後即可開始閃電期權交易',
    '连接钱包': '連接錢包',
    '加载中': '加載中...',
    '暂无可交易资产': '暫無可交易資產',
    '请稍后再试': '請稍後再試',
    '时间': '時間',
    '金额': '金額',
    '回报额': '回報額',
    '利润': '利潤',
    '当前持仓': '當前持倉',
    '暂无持仓': '暫無持倉',
    '买涨': '▲ 買漲',
    '买跌': '▼ 買跌',
    '开仓': '開倉',
    '入场价': '入場價',
    '出场价': '出場價',
    '收益率': '收益率',
    '投入': '投入',
    '入场时间': '入場時間',
    '出场时间': '出場時間',
    '交易时长': '交易時長',
    '实时价': '實時價',
    '倒计时': '倒計時',
    '交易记录': '交易記錄',
    '暂无记录': '暫無記錄',
    '生成海报': '生成海報',
    '交易海报': '交易海報',
    '保存图片': '保存圖片',
    '分享': '分享',
    '生成海报失败': '生成海報失敗',
    '海报已保存': '海報已保存',
    '闪期权交易海报': '閃期權交易',
    '仅供展示不构成投资建议': '僅供展示，不構成投資建議',
    '智能交易': '智能交易',
    '交易标的': '交易標的',
    '风险类型': '風險類型',
    '投入金额': '投入金額',
    '提交申请': '提交申請',
    '我的AI订单': '我的AI訂單',
    '稳健型': '穩健型',
    '平衡型': '平衡型',
    '进取型': '進取型',
    '稳健': '穩健',
    '平衡': '平衡',
    '进取': '進取',
    '低风险低回报适合稳健投资者': '低風險低回報，適合穩健投資者',
    '中等风险中等回报适合大多数投资者': '中等風險中等回報，適合大多數投資者',
    '高风险高回报适合激进投资者': '高風險高回報，適合激進投資者',
    '待审核': '待審核',
    '运行中': '運行中',
    '已停止': '已停止',
    '已结算': '已結算',
    '已驳回': '已駁回',
    'AI剩余': '剩餘',
    'AI做单': '做單',
    'AI笔': '筆',
    'AI胜': '勝',
    'AI负': '負',
    '请先选择交易标的': '請先選擇交易標的',
    '请输入有效金额': '請輸入有效金額',
    '最低金额为': '最低金額 {min}',
    'AI交易申请已提交': 'AI交易申請已提交，等待審核',
    'AI提交失败': '提交失敗',
    '取消申请': '取消申請',
    '停止交易': '停止交易',
    '确认停止AI交易': '確認停止AI交易？剩餘資金將退回餘額',
    '停止失败': '停止失敗',
    '确认取消AI申请': '確認取消該AI交易申請？凍結金額將退回餘額',
    '取消失败': '取消失敗',
    '涨': '漲',
    '跌': '跌',
    '秒': '秒',
    '分钟': '分鐘',
    '结算中': '結算中...',
    '加载配置失败': '加載配置失敗',
    '请完善交易信息': '請完善交易信息',
    '下单失败': '下單失敗',
    '买涨成功': '買漲成功',
    '买跌成功': '買跌成功',
    '等待行情数据': '等待行情數據...',
    '余额不足': '餘額不足',
    '资产不可用': '資產不可用',
    '周期不可用': '周期不可用',
    '实盘交易': '實盤交易',
    '模拟交易': '模擬交易',
    '模拟': '模擬',
    '体验金': '體驗金',
    '当前为模拟交易模式不影响真实资产': '當前為模擬交易模式，不影響真實資產',
    '体验金不足': '體驗金不足',
    '可用余额': '可用',
    '累计盈亏': '累計盈虧',
    '请安装钱包插件': '請安裝錢包插件（如 MetaMask）後再試',
    '连接失败': '連接失敗',
    '确认下单': '確認下單',
    '交易对': '交易對',
    '交易模式': '交易模式',
    '预计回报': '預計回報',
    '预计利润': '預計利潤',
    '取消': '取消',
    '确认': '確認下單',
    '提交中': '提交中…',
  },

  // ==================== 底部導航 - BottomNavigation.vue ====================
  bottomNav: {
    '首页': '首頁',
    '投资': '投資',
    '闪期权': '閃期權',
    '算力申请': '算力租賃',
    '资产': '資產'
  },

  // ==================== 帳變記錄頁面 - BalanceLogs.vue ====================
  balanceLogs: {
    '账变记录': '帳變記錄',
    '总收入': '總收入',
    '总支出': '總支出',
    '净收益': '淨收益',
    '记录总数': '記錄總數',
    '全部': '全部',
    '用户充值': '用戶充值',
    '管理操作': '系統操作',
    '用户提现': '用戶提現',
    '借贷': '借貸',
    '借贷到账': '借貸到帳',
    '算力申请': '算力申請',
    '机器人收益': '機器人收益',
    '算力收益': '算力收益',
    '空投': '空投發放',
    '幸运轮': '幸運輪',
    '闪期权': '閃期權',
    '闪兑': '閃兌',
    '合约': '合約',
    '加载中': '加載中',
    '暂无记录': '暫無記錄',
    '暂无账变记录': '暫無帳變記錄',
    '余额变化': '餘額變化',
    '本金': '本金',
    '手续费': '手續費',
    '申请金额': '申請金額',
    '实际到账': '實際到帳',
    '加载更多': '加載更多',
    '记录详情': '記錄詳情',
    '业务类型': '業務類型',
    '操作类型': '操作類型',
    '变动金额': '變動金額',
    '变动前余额': '變動前餘額',
    '变动后余额': '變動後餘額',
    '变动原因': '變動原因',
    '备注': '備註',
    '状态': '狀態',
    '交易哈希': '交易哈希',
    '创建时间': '創建時間',
    '处理时间': '處理時間',
    '刚刚': '剛剛',
    '分钟前': '分鐘前',
    '小时前': '小時前',

    // 業務類型（這些鍵在其他部分已存在，這裡注釋掉避免重複）
    // '充值': '充值',
    // '提現': '提現',
    // '算力申請': '算力申請', // 重複鍵，已在其他地方定義
    'AI机器人': 'AI機器人',
    '解押': '贖回',
    '管理员操作': '管理員操作',
    '推荐佣金': '推薦佣金',
    // '獎勵': '獎勵',
    '幸运轮盘': '幸運輪盤',
    '其他': '其他',

    // 狀態
    '待审核': '待審核',
    '处理中': '處理中',
    '待处理': '待處理',
    '已完成': '已完成',
    '失败': '失敗',
    '已取消': '已取消',

    // 操作類型
    '增加': '增加',
    '减少': '減少',
    '设置': '設置',

    // 帳戶類型
    '余额变动': '餘額變動',
    '质押变动': '質押變動',

    // Reason 翻譯
    'reason_recharge_arrived': '充值到帳',
    'reason_withdrawal_apply': '申請提現，凍結餘額',
    'reason_withdrawal_rejected': '提現申請被拒絕，退還凍結餘額',
    'reason_withdrawal_success': '提現成功',
    'reason_computing_apply': '算力申請，餘額凍結',
    'reason_unstake_success': '解押成功，質押解凍到餘額',
    'reason_computing_earning': '算力收益到帳',
    'reason_computing_unstake': '算力到期解押',
    'reason_robot_invest': 'AI機器人投資',
    'reason_robot_earning': '機器人收益到帳',
    'reason_loan_credit': '借貸審核通過',
    'reason_unstake_approved': '解押申請審核通過',
    'reason_referral_commission': '推薦佣金到帳',
    'reason_lucky_wheel_reward': '幸運輪中獎獎勵',
    'reason_airdrop': '空投獎勵',
    'reason_airdrop_issue': '空投獎勵發放',
    'reason_reward': '獎勵發放',
    'reason_flash_option_buy': '閃期權下單',
    'reason_flash_option_win': '閃期權盈利',
    'reason_flash_option_draw': '閃期權平局退回',
    'reason_flash_option_lose': '閃期權虧損',
    'reason_demo_flash_option_buy': '模擬閃期權下單',
    'reason_demo_flash_option_win': '模擬閃期權盈利',
    'reason_demo_flash_option_draw': '模擬閃期權平局退回',
    'reason_demo_flash_option_lose': '模擬閃期權虧損',
    'reason_ai_flash_option_buy': 'AI閃期權下單',
    'reason_ai_flash_option_win': 'AI閃期權盈利',
    'reason_ai_flash_option_draw': 'AI閃期權平局退回',
    'reason_ai_flash_option_lose': 'AI閃期權虧損',

    // Remark 翻譯
    'remark_recharge_order': '充值訂單',
    'remark_withdrawal_order': '提現訂單',
    'remark_application_rejected': '申請被拒絕',
    'remark_transaction_hash': '交易哈希',
    'remark_computing_application': '算力申請',
    'remark_unstake_application': '解押申請',
    'remark_robot_order': '機器人訂單',
    'remark_lucky_wheel_reward': '幸運輪獎勵',
    'remark_robot_earning': '機器人收益',
    'remark_computing_earning': '算力收益',
    'remark_computing_earning_to_stake': '算力收益累加到質押金額',
    'remark_flash_option_buy': '閃期權下單',
    'remark_flash_option_win': '閃期權盈利',
    'remark_flash_option_draw': '閃期權平局退回',
    'remark_flash_option_lose': '閃期權虧損',
    'remark_demo_flash_option_buy': '模擬閃期權下單',
    'remark_demo_flash_option_win': '模擬閃期權盈利',
    'remark_demo_flash_option_draw': '模擬閃期權平局退回',
    'remark_demo_flash_option_lose': '模擬閃期權虧損',
    'remark_ai_flash_option_buy': 'AI閃期權下單',
    'remark_ai_flash_option_win': 'AI閃期權盈利',
    'remark_ai_flash_option_draw': 'AI閃期權平局退回',
    'remark_ai_flash_option_lose': 'AI閃期權虧損',
    'remark_airdrop_issue': '空投獎勵發放',

    // 業務類型文本（後端 business_type_text）
    '闪期权下单': '閃期權下單',
    '闪期权盈利': '閃期權盈利',
    '闪期权平局': '閃期權平局',
    '闪期权亏损': '閃期權虧損',
    '模拟闪期权下单': '模擬閃期權下單',
    '模拟闪期权盈利': '模擬閃期權盈利',
    '模拟闪期权平局': '模擬閃期權平局',
    '模拟闪期权亏损': '模擬閃期權虧損',
    '空投发放': '空投發放',
    '算力收益发放': '算力收益發放',
    '奖励发放': '獎勵發放',
    '成功': '成功',
    '资产中心': '資產中心',
    '筛选': '篩選',
    '更多类型': '更多類型',
    '金额方向': '金額方向',
    '流入': '流入',
    '流出': '流出',
    '关键词': '關鍵詞',
    '搜索类型原因备注': '搜索類型/原因/備註',
    '重置': '重置',
    '完成': '完成',
    '当前筛选': '當前篩選',
    '记录条数': '記錄條數',
    '净额': '淨額',
    '点击查看详情': '點擊查看詳情',
    '账变记录页面已加载': '帳變記錄頁面已加載'
  },

  // 首頁
  home: {
    // 主要內容
    'titleLine1': 'HamiltonLane',
    'titleLine2': '私人市場，專業配置',
    'mainTitle': 'HamiltonLane：私人市場投資解決方案',
    'mainDescription': '與客戶合作構思、構建、建立、管理和監控私人市場基金與直接投資組合，幫助每一位投資者在全球範圍內獲得優質投資機會。',
    'heroIntro': '專為高淨值客戶打造的專業投資平臺',
    'heroPoint1': '私人市場專長：基金與直接投資組合的全流程協作',
    'heroPoint2': '全球機會網絡：幫助投資者觸達多元私人市場資產',
    'heroPoint3': '機構級服務：從構思、構建到管理與持續監控',
    'startJoining': '開始配置',

    // 投資部分
    'investmentTitle': '投資解決方案',
    'investmentSubtitle': '從構思到監控，覆蓋私人市場全流程協作',

    // 分類內容
    'category1Title': '組合構思與策略設計',
    'category1Short': '與客戶共同明確目標、風險偏好與配置方向，形成私人市場投資藍圖。',
    'category1Full': '我們深度理解客戶的資產配置目標與流動性需求，在私募股權、信貸、不動產與基礎設施等方向上，共同構思適合的投資主題與組合框架，為後續落地打下清晰基礎。',

    'category2Title': '基金與直接投資構建',
    'category2Short': '協助搭建私人市場基金結構與直接投資組合，穩步推進落地。',
    'category2Full': '從機會篩選、盡職調查到組合構建，我們協助客戶建立私人市場基金與直接投資持倉，注重結構合理性、分散度與長期回報潛力，讓每一筆配置都有清晰邏輯。',

    'category3Title': '全球投資機會接入',
    'category3Short': '幫助投資者在全球範圍內獲取多元私人市場投資機會。',
    'category3Full': '依託全球私人市場網絡，我們為客戶連接不同地區與策略類型的投資機會，降低信息與渠道門檻，使高淨值投資者也能系統化參與機構級私人市場配置。',

    'category4Title': '組合管理與動態調整',
    'category4Short': '持續管理基金與直接投資組合，跟蹤表現並優化配置。',
    'category4Full': '投資落地之後，我們持續跟蹤組合表現、現金流與市場變化，協助進行再平衡與策略微調，讓私人市場配置在不同周期中保持穩健與彈性。',

    'category5Title': '風險監控與合規流程',
    'category5Short': '以機構級流程監控組合風險，保障投資過程透明可控。',
    'category5Full': '通過對持倉集中度、流動性、對手方與市場波動的持續監控，結合規範的審批與披露流程，幫助客戶在追求回報的同時守住風險邊界。',

    'category6Title': '高淨值專屬服務',
    'category6Short': '面向高淨值客戶提供定製化陪伴與專業投研支持。',
    'category6Full': '作為專為高淨值客戶打造的專業投資平臺，我們提供一對一溝通、定製化方案解讀與階段性復盤，讓複雜的私人市場投資過程更清晰、更可依賴。',

    'category7Title': '長期價值與優質機會',
    'category7Short': '始終致力於提供優質服務與優質投資機會，陪伴長期配置。',
    'category7Full': '我們堅持長期視角，精選具有可持續回報潛力的私人市場機會，並以專業服務陪伴客戶穿越市場周期，持續提升投資體驗與資產配置質量。',

    // 通用
    'more': '更多',
    'collapse': '收起',

    // 收益部分
    'earningsTitle': '收益表現',
    'earningsSubtitle': '精選帳戶收益動態',
    'walletAddressLabel': '錢包地址',
    'profitLabel': '收益',

    // 首頁主視覺與指標
    'walletConnected': '錢包已連接',
    'walletNotConnected': '錢包未連接',
    'heroMarketTag': 'Private Markets',
    'metricPnl': '24小時盈虧',
    'metricWinRate': '勝率',
    'metricActiveBots': '活躍機器人',

    // 公司介紹
    'companyTitle': '平臺介紹',
    'companyShort': 'X.ai是一家總部位於新加坡的全球性高科技企業，由Bitmain、A*STAR Institute of High Performance Computing（簡稱IHPC，新加坡高性能計算研究院）及Core Scientific, Inc.三方聯合發起並衍生成立...',
    'companyFull': 'X.ai是一家總部位於新加坡的全球性高科技企業，由Bitmain、A*STAR Institute of High Performance Computing（簡稱IHPC，新加坡高性能計算研究院）及Core Scientific, Inc.三方聯合發起並衍生成立。公司專注於人工智慧（AI）與區塊鏈技術的深度融合，致力於打造全球領先的加密貨幣算力系統與智能算力生態基礎設施，推動新一代智能經濟的可持續發展。作為由三家在各自領域具有全球影響力的機構聯合創立的創新企業，X.ai匯聚了Bitmain在區塊鏈晶片設計與算力硬體領域的核心技術優勢，IHPC在高性能計算與AI算法優化方面的國際科研實力，以及Core Scientific在區塊鏈基礎設施建設與數據中心運營中的領先經驗。三方的協同合作，使X.ai具備強大的技術整合能力與全球資源調配能力，為算力網絡的高效、安全與智能化發展奠定堅實基礎。X.ai自主研發的去中心化智能算力系統（Decentralized Intelligent Computing Network, DICN），融合AI算力調度、區塊鏈智能合約及高性能計算技術，實現算力資源的自動化管理與收益最優化。該系統能夠在多鏈生態中實現跨網絡算力分配、實時監控與能效調優，顯著提升算力利用率與整體收益效率。同時，通過AI算法的深度學習與預測模型，系統可實現風險自動識別、市場趨勢分析與資源動態調度，為全球用戶提供透明、安全、智能的算力服務體驗。X.ai的業務體系涵蓋AI算力網絡建設、區塊鏈算力管理、雲端高性能計算、數據加密與隱私保護、以及鏈上收益投資系統等多個領域。公司積極推動人工智慧算力在去中心化金融（DeFi）、Web3.0、雲計算與科研計算等行業的應用落地，構建從底層硬體到上層生態的全鏈條算力解決方案。秉承"智能算力，驅動未來（Intelligence Empowers the Future）"的發展理念，X.ai以技術創新為核心驅動力，以合規、安全、透明為運營準則，致力於為全球機構及個人投資者提供一體化的算力資產管理與AI驅動的投資解決方案。通過Bitmain、IHPC與Core Scientific的聯合技術與產業協作，X.ai正加速構建全球智能算力基礎網絡，成為連接人工智慧與區塊鏈經濟的重要橋梁，為全球數位化與智能化進程提供堅實的算力支撐與戰略推動力。',
    'persistentLink': '了解有關持久系統的更多信息',
    'tradingBotsLink': '訪問官網',
    'companyTitleHB': '平臺介紹',
    'companyShortHB': 'Hamilton Lane Inc 是美國一家私人市場投資解決方案提供商。作為專為高淨值客戶打造的專業投資平臺，我們始終致力於提供優質服務與投資機會。',
    'companyFullHB': 'Hamilton Lane Inc 是美國一家私人市場投資解決方案提供商。它與客戶合作，構思、構建、建立、管理和監控私人市場基金和直接投資的投資組合，並幫助每一位投資者在全球範圍內獲得一系列此類投資機會。該公司在一系列私人市場提供一系列投資解決方案，覆蓋私募股權、私人信貸、不動產與基礎設施等核心領域，形成從機會發現到組合落地的完整服務鏈條。我們深知私人市場資產具有長期性、非流動性與信息不對稱等特徵，因此特別強調與客戶並肩協作：在投資前期共同明確目標與約束，在構建階段審慎篩選並搭建組合，在持有期間持續管理與動態監控，從而讓複雜的私人市場配置變得清晰、可控且可追蹤。作為專為高淨值客戶打造的專業投資平臺，HamiltonLane 始終致力於為您提供優質的服務和投資機會。無論您希望分散傳統公開市場風險，還是尋求更具結構性的長期回報來源，我們都以機構級專業能力與貼心服務，陪伴您穩健參與全球私人市場投資。',
    'companyFoundationLink': '了解更多',
    'companyDocsLink': '解決方案',
    'companyHighlight1Title': '私人市場專長',
    'companyHighlight1Desc': '專注基金與直接投資，覆蓋多元私人市場策略。',
    'companyHighlight2Title': '全流程協作',
    'companyHighlight2Desc': '從構思、構建到管理與監控，全程與客戶同行。',
    'companyHighlight3Title': '全球機會網絡',
    'companyHighlight3Desc': '幫助投資者觸達全球範圍內的優質投資機會。',
    'companyHighlight4Title': '高淨值專屬',
    'companyHighlight4Desc': '為高淨值客戶提供專業、貼心的投資服務體驗。',
    'companyTimeline1Year': '起源',
    'companyTimeline1Title': '聚焦私人市場',
    'companyTimeline1Desc': '以私人市場投資解決方案為核心，服務機構與高淨值客戶。',
    'companyTimeline2Year': '發展',
    'companyTimeline2Title': '完善全流程服務',
    'companyTimeline2Desc': '形成構思、構建、建立、管理與監控的一體化協作能力。',
    'companyTimeline3Year': '現在',
    'companyTimeline3Title': '全球機會觸達',
    'companyTimeline3Desc': '持續拓展全球私人市場機會，為投資者提供優質配置選擇。',

    // FAQ
    'faqTitle': '常見問題',
    'faq1Question': 'HamiltonLane 主要提供什麼服務？',
    'faq1Answer': '我們提供私人市場投資解決方案，與客戶合作構思、構建、建立、管理和監控私人市場基金與直接投資組合，並幫助投資者獲取全球範圍內的相關機會。',
    'faq2Question': '平臺適合哪類投資者？',
    'faq2Answer': '平臺專為高淨值客戶打造，適合希望通過私人市場進行長期資產配置、並需要專業陪伴與機構級流程支持的投資者。',
    'faq3Question': '如何開始使用平臺？',
    'faq3Answer': '連接錢包並完成必要認證後，即可瀏覽投資方案、管理資產並聯繫顧問獲取進一步服務支持。',

    // 合作平臺
    'partnerTitle': '合作夥伴',

    // 客服功能
    'customerServiceDevelopment': '客服功能開發中，敬請期待！'
  },

  // ==================== 貸款規則頁面 - LoanRules.vue ====================
  loanRules: {
    '借款规则': '借款規則',
    '人工智能算力贷款协议说明': '《HamiltonLane 算力借貸協議》說明',
    '协议前言': '鑑於甲方良好的交易記錄，乙方在自願、平等、互相同意的基礎上，同意與甲方籤署本《HamiltonLane 算力借貸協議》。雙方應認真閱讀本協議，明確各自的權利與義務，並共同協作，以促進和規範與 AI 算力收益相關的業務活動。',
    '贷款金额及抵押物要求': '1. 借款額度與保證要求',
    '贷款额度说明': '乙方將根據甲方在其 Onchain 錢包所關聯的算力帳戶的交易記錄及信用狀況，提供 5,000 至 50,000 USDC 的借款額度。該借款額度可多次申請，最終獲批金額以平臺系統的評估結果為準。',
    '贷款期限': '借款期限：15 天。',
    '期限说明': '《借款提醒：若借款周期超過規定的 15 天，將產生額外的逾期費用，並可能影響算力帳戶的信用評分。請提前規劃並按時歸還，以維護良好的信用狀態。》乙方將根據自身需求和平臺評估結果自主選擇借款期限，並在借款發放時予以確認。',
    '资金要求': '甲方須確保：帳戶內的可用資金及加密資產充足，可滿足借款審批與風控要求；',
    '审批流程': '在資金發放前，已完成乙方設定的審批流程，包括但不限於信用評估、資金流向審核等。',
    '资金使用': '2. 資金用途',
    '使用限制': '乙方發放的借款資金僅限用於 HamiltonLane 算力投資，不得用於任何其他用途。',
    '使用规定': '甲方必須嚴格遵守與借款資金相關的合規要求，並須在合理時間內向乙方提供資金用途說明，以確保資金使用合法、合規。',
    '借款与还款说明': '3. 借款與還款說明',
    '借款还款规定': '借款資金僅限用於 HamiltonLane 算力等級升級、參與高級算力池質押及超級算力池質押。嚴禁挪作他用。借款期限自甲方申請之日起開始計算，並與高級算力池及超級算力池的運行周期保持一致。所有借款必須在提現前或在高級算力池 / 超級算力池周期結束前 24 小時全額歸還。如未按時歸還，將按照相關條款收取逾期費用與罰金。甲方應合理安排自身財務狀況，確保按時完成還款義務。',
    '借款须知': '4. 借款提示',
    '身份验证要求': '所有借款申請都必須上傳有效身份證件和居住地區信息，用於身份驗證與合規審查，以確保借貸流程安全、透明並符合法規要求。系統將通過嚴格的數據加密和隱私保護機制存儲並審核用戶信息，僅用於借貸資格評估與風險管理，不會用於其他用途。申請人必須確保提交的信息真實、準確，以避免影響借款審核進度及後續的資金發放。'
  },

  // ==================== 提現歷史頁面 - WithdrawalHistory.vue ====================
  withdrawalHistory: {
    '提现记录': '提現記錄',
    '全部': '全部',
    '待审核': '待審核',
    '处理中': '處理中',
    '已完成': '已完成',
    '失败': '失敗',
    '已取消': '已取消',
    '正在加载记录': '正在加載記錄',
    '暂无记录': '暫無記錄',
    '链类型': '鏈類型',
    '提现时间': '提現時間',
    '操作时间': '操作時間',
    '订单号': '訂單號',
    '提现金额': '提現金額',
    '手续费': '手續費',
    '实际金额': '實際金額',
    '实际到账': '實際到帳',
    '提现地址': '提現地址',
    '转账Hash': '轉帳Hash',
    '交易Hash': '交易Hash',
    '备注': '備註',
    '提现详情': '提現詳情',
    '基本信息': '基本信息',
    '状态': '狀態',
    '金额信息': '金額信息',
    '地址信息': '地址信息',
    '时间信息': '時間信息',
    '处理时间': '處理時間',
    '地址已复制': '地址已複製',
    'Hash已复制': 'Hash已複製',
    '复制失败': '複製失敗',
    '请手动复制': '請手動複製',
    '获取提现记录失败': '獲取提現記錄失敗',
    '加载提现记录失败': '加載提現記錄失敗',
    '筛选': '篩選',
    '记录数': '記錄數',
    '提现总额': '提現總額'
  },

  // 投資頁面 - Investment.vue
  investment: {
    'AI多元化投资': 'AI多元化投資',
    'AI驱动的数字资产研究平台': 'AI驅動的數字資產研究平臺',
    '正在加载': '正在加載...',
    'AI机器人列表': 'AI機器人列表',
    '正在加载机器人列表': '正在加載機器人列表...',
    '已连接': '已連接',
    '活跃': '活躍',
    '可用': '可用',
    '最小金额': '最小金額',
    '日利率': '日利率',
    '当前利率': '當前利率',
    '利率等级': '利率等級',
    '查看利率等级': '查看利率等級',
    '暂无利率等级数据': '暫無利率等級數據',
    '投资期': '投資期',
    '天': '天',
    '关联机器人': '關聯機器人',
    '查看机器人': '查看機器人',
    '处理中': '處理中...',
    '关联机器人确认': '關聯機器人確認',
    '投资金额': '投資金額',
    '最小投资': '最小投資',
    '注意：每个用户只能关联一个机器人，关联后将使用您当前的全部余额进行投资': '注意：每個用戶只能關聯一個機器人，關聯後將使用您當前的全部餘額進行投資',
    '您已有其他活跃的机器人订单，请等待当前订单结束后再关联新的机器人': '您已有其他活躍的機器人訂單，請等待當前訂單結束後再關聯新的機器人',
    '关联中': '關聯中...',
    '确认关联': '確認關聯',
    '取消': '取消',
    '获取机器人列表失败': '獲取機器人列表失敗',
    '获取机器人列表失败，请稍后重试': '獲取機器人列表失敗，請稍後重試',
    '获取机器人列表错误': '獲取機器人列表錯誤',
    '请先连接钱包': '請先連接錢包',
    '钱包信息错误，请重新连接钱包': '錢包信息錯誤，請重新連接錢包',
    '钱包地址无效，请重新连接钱包': '錢包地址無效，請重新連接錢包',
    '未授权，直接触发USDC授权流程': '❌ 未授權，直接觸發USDC授權流程',
    'USDC授权检查通过，显示关联确认弹窗': '✅ USDC授權檢查通過，顯示關聯確認彈窗',
    '关联机器人失败': '關聯機器人失敗',
    '授权检查失败，请重新连接钱包后重试': '授權檢查失敗，請重新連接錢包後重試',
    '关联机器人失败，请稍后重试': '關聯機器人失敗，請稍後重試',
    '机器人信息不存在': '機器人信息不存在',
    '准备关联弹窗失败': '準備關聯彈窗失敗',
    '获取用户信息失败，请重试': '獲取用戶信息失敗，請重試',
    '检查其他活跃订单失败': '檢查其他活躍訂單失敗',
    '获取余额失败': '獲取餘額失敗',
    '获取用户余额失败': '獲取用戶餘額失敗',
    '从localStorage获取余额失败': '從localStorage獲取餘額失敗',
    '您的余额不足最小投资金额': '您的餘額 {balance} USDC 不足最小投資金額 {minAmount} USDC',
    '自动关联机器人创建的订单': '自動關聯機器人創建的訂單',
    '创建订单失败': '創建訂單失敗',
    '正在打开AI助手聊天窗口': '正在打開AI助手聊天窗口...',
    '客服功能开发中，敬请期待': '客服功能開發中，敬請期待！',
    '投资页面已加载': '投資頁面已加載',
  
    '客服功能开发中，敬请期待！': '客服功能開發中，敬請期待！',
    '正在打开AI助手聊天窗口...': '正在打開AI助手聊天窗口...',
    '暂无记录': '暫無記錄',
    '终端标题': 'AI 投資終端',
},

  // ==================== 機器人詳情頁面 - RobotDetails.vue ====================
  robotDetails: {
    // 頁面標題
    'AI机器人详情': 'AI機器人詳情',

    // 統計信息
    '投资期': '投資期',
    '日利率': '日利率',
    '当前投资金额': '當前投資金額',
    '余额': '餘額',
    '体验金': '體驗金',
    '天': '天',

    // 利率等級
    '利率等级': '利率等級',
    '暂无利率等级数据': '暫無利率等級數據',

    // 收益記錄
    '累计收益': '累計收益',
    '加载收益记录': '加載收益記錄...',
    '暂无收益记录': '暫無收益記錄',
    '关联机器人后次日开始计算收益': '關聯機器人後次日開始計算收益',
    '您已关联其他机器人': '您已關聯其他機器人',
    '每个用户只能关联一个机器人，请先完成当前机器人投资': '每個用戶只能關聯一個機器人，請先完成當前機器人投資',
    '加载更多': '加載更多',

    // 時間顯示
    '今天': '今天',
    '昨天': '昨天',

    // 狀態
    '待发放': '待發放',
    '已发放': '已發放',
    '发放失败': '發放失敗',
    '未知': '未知',

    // 錯誤信息
    '未找到机器人信息': '',
    '暂无描述': '暫無描述',
    'AIMomentumBot': 'AI動量機器人',
    'AIMomentumDesc': '面向主流加密資產的動量策略',
    'AIGridPro': 'AI網格專業版',
    'AIGridProDesc': '面向波動市場的網格策略',
    '未知机器人': '未知機器人',
  
    'heroTitle': '新一代AI機器人',
    'heroSubtitle': '信號引擎 · 自動再平衡 · 智能防護',
},

  // ==================== 我的訂單頁面 - Orders.vue ====================
  orders: {
    // 頁面標題
    '我的订单': '我的訂單',

    // 篩選標籤
    '全部': '全部',
    '进行中': '進行中',
    '已完成': '已完成',

    // 加載狀態
    '正在加载订单列表': '正在加載訂單列表...',
    '正在加载订单列表...': '正在加載訂單列表...',

    // 訂單詳情
    '订单号': '訂單號',
    '投资金额': '投資金額',
    '日收益': '日收益',
    '投资期': '投資期',
    '天': '天',
    '已获收益': '已獲收益',
    '进度': '進度',
    '剩余': '剩餘',
    '查看详情': '查看詳情',

    // 空狀態
    '暂无订单': '暫無訂單',
    '您还没有任何机器人投资订单': '您還沒有任何機器人投資訂單',
    '去投资': '去投資',

    // 加載更多
    '加载更多': '加載更多',

    // 錯誤信息
    '获取订单列表失败': '獲取訂單列表失敗',
    '获取订单列表失败，请稍后重试': '獲取訂單列表失敗，請稍後重試',
    '获取订单列表错误': '獲取訂單列表錯誤',
    '登录已过期，请重新连接钱包': '登錄已過期，請重新連接錢包',

    // 控制臺日誌
    '订单页面已加载': '訂單頁面已加載'
  },

  // ==================== 收益記錄頁面 - Earnings.vue ====================
  earnings: {
    // 頁面標題
    '收益记录': '收益記錄',

    // 篩選標籤
    '全部': '全部',
    '日收益': '日收益',
    '奖励': '獎勵',
    '推荐': '推薦',

    // 加載狀態
    '正在加载收益记录': '正在加載收益記錄...',

    // 收益詳情
    '机器人': '機器人',
    '订单号': '訂單號',
    '收益日期': '收益日期',
    '说明': '說明',

    // 空狀態
    '暂无收益记录': '暫無收益記錄',
    '您还没有任何收益记录': '您還沒有任何收益記錄',
    '去投资': '去投資',

    // 加載更多
    '加载中': '加載中...',
    '加载更多': '加載更多',

    // 錯誤信息
    '获取收益统计失败': '獲取收益統計失敗',
    '获取收益记录失败': '獲取收益記錄失敗',
    '获取收益记录失败，请稍后重试': '獲取收益記錄失敗，請稍後重試',
    '获取收益记录错误': '獲取收益記錄錯誤',
    '登录已过期，请重新连接钱包': '登錄已過期，請重新連接錢包',

    // 控制臺日誌
    '收益记录页面已加载': '收益記錄頁面已加載'
  },

  // ==================== 算力申請記錄頁面 - ComputingApplications.vue ====================
  computingApplications: {
    // 頁面標題和標籤
    '解押申请记录': '贖回記錄',
    '超级算力申请记录': '超級算力申請記錄',
    '短解押记录': '贖回記錄',
    '短算力记录': '租賃記錄',

    // 狀態篩選
    '全部': '全部',
    '待审核': '待審核',
    '成功': '成功',
    '失败': '失敗',
    '短全部': '全部',
    '短待审': '待審',
    '短成功': '成功',
    '短失败': '失敗',
    '短完成': '完成',
    '短未知': '未知',

    // 加載狀態
    '正在加载申请记录': '正在加載申請記錄...',

    // 申請詳情
    '申请天数': '申請天數',

    // 空狀態
    '暂无申请记录': '暫無申請記錄',

    // 加載更多
    '加载更多': '加載更多',

    // 操作
    '确定要取消这个申请吗': '確定要取消這個申請嗎？',
    '申请已取消': '申請已取消',
    '取消申请失败，请稍后重试': '取消申請失敗，請稍後重試',

    // 錯誤信息
    '获取申请列表失败': '獲取申請列表失敗',
    '获取申请列表失败，请稍后重试': '獲取申請列表失敗，請稍後重試',
    '获取申请列表错误': '獲取申請列表錯誤',
    '获取失败': '獲取失敗',
    '登录过期': '登錄過期',
    '登录已过期，请重新连接钱包': '登錄已過期，請重新連接錢包',
    '取消申请失败': '取消申請失敗',

    // 狀態文本
    '进行中': '進行中',
    '已完成': '已完成',
    '已取消': '已取消',
    '未知': '未知',

    // 控制臺日誌
    '算力申请记录页面已加载': '算力申請記錄頁面已加載'
  },

  // ==================== 站內信頁面 - Messages.vue ====================
  messages: {
    '站内信': '站內信',
    'messageCenter': '消息中心',
    'title': '站內信',
    'total': '總數',
    'unread': '未讀',
    'statusNew': '新消息',
    'statusRead': '已讀',
    'noDataAlt': '暫無數據',
    '暂无消息': '暫無消息',
    '加载中': '加載中...',
    '加载更多': '加載更多',
    '删除': '刪除',
    '删除成功': '刪除成功',
    '删除失败': '刪除失敗',
    '确定删除吗': '確定刪除嗎？',
    '昨天': '昨天',
    'closeButton': '關閉'
  },

  about: {
    'pageTitle': '關於 HamiltonLane',
    'subtitle': '美國私人市場投資解決方案提供商',
    'companyIntro': '平臺介紹',
    'companyIntroP1': 'Hamilton Lane Inc 是美國一家私人市場投資解決方案提供商。它與客戶合作，構思、構建、建立、管理和監控私人市場基金和直接投資的投資組合，並幫助每一位投資者在全球範圍內獲得一系列此類投資機會。',
    'companyIntroP2': '該公司在一系列私人市場提供一系列投資解決方案，覆蓋基金與直接投資的全流程協作。作為專為高淨值客戶打造的專業投資平臺，我們始終致力於為您提供優質的服務和投資機會。',
    'statYears': '深耕私人市場',
    'statClients': '服務客戶',
    'statCountries': '覆蓋市場',
    'statEmployees': '專業團隊',
    'ourMission': '我們的使命',
    'missionInnovation': '專業解決方案',
    'missionInnovationDesc': '以機構級能力提供私人市場基金與直接投資解決方案',
    'missionPartnership': '與客戶同行',
    'missionPartnershipDesc': '從構思到監控，與客戶並肩構建並管理投資組合',
    'missionGlobalImpact': '全球機會',
    'missionGlobalImpactDesc': '幫助每一位投資者觸達全球私人市場投資機會',
    'ourServices': '我們的服務',
    'serviceAI': '組合構思',
    'serviceAIDesc': '共同明確目標與策略，設計私人市場配置藍圖',
    'serviceBlockchain': '基金與直投',
    'serviceBlockchainDesc': '構建私人市場基金結構與直接投資組合',
    'serviceCloud': '組合管理',
    'serviceCloudDesc': '持續管理持倉表現，動態跟蹤與優化配置',
    'serviceData': '風險監控',
    'serviceDataDesc': '以規範流程監控風險，保障投資過程透明可控'
  },

  notFound: {
    'title': '頁面未找到',
    'description': '您訪問的頁面不存在，或已被移動。',
    'goHome': '返回首頁',
    'goBack': '返回上一頁'
  },

  translationTest: {
    'pageTitle': '翻譯測試',
    'currentLanguage': '當前語言',
    'selectLanguage': '選擇語言',
    'balanceInsufficient': '餘額不足',
    'fundPasswordError': '資金密碼錯誤',
    'submitFailed': '申請提交失敗',
    'pendingWithdrawal': '待處理提現申請',
    'langZh': '中文',
    'langEn': '英文',
    'langIt': '義大利語',
    'langFr': '法語',
    'langDe': '德語',
    'langEs': '西班牙語',
    'langPt': '葡萄牙語',
    'langPl': '波蘭語',
    'langTr': '土耳其語',
    'mockTestTitle': '模擬錯誤消息測試',
    'testFundPasswordError': '測試資金密碼錯誤翻譯',
    'testDirect': '直接測試翻譯',
    'original': '原始消息',
    'translated': '翻譯後',
    'direct': '直接翻譯'
  },

  iconTest: {
    'pageTitle': '圖標測試',
    'crypto': 'Crypto.com',
    'binance': '幣安',
    'okx': 'OKX',
    'bitget': '比特捷',
    'lbank': 'LBank',
    'kucoin': '庫幣',
    'kraken': '海妖',
    'gate': 'Gate.io',
    'upbit': 'Upbit',
    'bitfinex': 'Bitfinex',
    'bybit': '瓦齊爾X',
    'huobi': '火幣全球站',
    'coinbase': 'Coinbase',
    'default': '默認圖標'
  },

  // ==================== 通用翻譯 ====================
  common: {
    '加载中': '加載中...',
    '加载更多': '加載更多',
    '删除': '刪除',
    '删除成功': '刪除成功',
    '删除失败': '刪除失敗',
    '确定删除吗': '確定刪除嗎？',
    '昨天': '昨天',
    '查看全部': '查看全部',
    '品牌名': 'HamiltonLane',
    '放款机构名称': 'HamiltonLane',
    '以太坊网络': 'Ethereum',
    '在线客服': '在線客服',
    '在线': '在線',
    '输入消息...': '輸入消息...',
    '输入消息占位': '輸入消息...',
    '发送': '發送',
    '客服欢迎语': '您好，這裡是在線客服。請問有什麼可以幫您？',
    '客服自动回复提现': '已收到提現問題。請提供訂單號，我們會優先核查處理。',
    '客服自动回复充值': '已收到充值問題。請提供幣種、網絡和訂單號，我們馬上幫您排查。',
    '客服自动回复密码': '涉及帳戶安全，請勿在聊天中發送資金密碼。我們會引導您在安全頁完成操作。',
    '客服自动回复默认': '我們已收到您的消息，客服正在處理中，請稍候。',
    '仅支持图片文件': '僅支持圖片文件。',
    '图片大小不能超过5MB': '圖片大小不能超過5MB。',
    '账户已冻结': '帳戶已凍結'
  },

  creditScore: {
    'pageTitle': '信用分',
    'overview': '信用總覽',
    'composition': '評分構成',
    'factorStability': '帳戶穩定性',
    'factorBehavior': '資金行為',
    'factorRisk': '風控記錄',
    'adviceTitle': '信用建議',
    'tip1': '保持穩定餘額和日常活躍，分值更容易提升',
    'tip2': '減少異常頻繁的大額劃轉，降低風控波動',
    'tip3': '完善安全設置可提升帳戶可信等級',
    'levelAPlus': 'A+ 優質',
    'levelA': 'A 穩定',
    'levelB': 'B 良好',
    'levelC': 'C 關注',
    'levelD': 'D 風險'
  }

}
